export default __webpack_public_path__ + "static/media/UniLogo.56f6df29.svg";